import {Features, type Feature} from "../feature";
import type {FeatureType} from "./SerializedFeature";

/**
 * Map a runtime Feature to its high-level type classification.
 *
 * Replaces the dot-notation string parsing that consumers had to do
 * to discriminate between rings, chains, functional groups, etc.
 */
export function classifyFeature(feature: Feature): FeatureType {
    const name = feature.name;

    // Bridged bicyclic must be checked before generic ring (it starts with "ring.bridge")
    if (name.startsWith(Features.bridgedRing)) return "bridged_bicyclic";
    if (name === Features.ringSystem || name.startsWith(`${Features.ringSystem}.`)) return "ring";
    if (name === Features.ring || name.startsWith(`${Features.ring}.`)) return "ring";

    // PIPH-116: Methyl with a parent is a functional group, not a chain
    if (name === Features.methyl && feature.parent) {
        return "functional_group";
    }

    if (name === Features.chain || name.startsWith(`${Features.chain}.`)) return "chain";

    if (name === Features.molecule || name.startsWith(`${Features.molecule}.`)) return "molecule";

    if (name === Features.atomCluster) return "atom_cluster";

    if (name === Features.atom || name.startsWith(`${Features.atom}.`)) return "atom";

    // Default — anything else is a functional group (alcohol, ester, ether, amine, etc.)
    return "functional_group";
}
